import {
  BANK_INTEGRATION_ADD_REQUEST,
  BANK_INTEGRATION_ADD_REQUEST_FAILURE,
  BANK_INTEGRATION_ADD_REQUEST_SUCCESS,
  BANK_INTEGRATION_FETCH_REQUEST,
  BANK_INTEGRATION_FETCH_REQUEST_SUCCESS,
  BANK_INTEGRATION_FETCH_REQUEST_FAILURE,
  BANK_INTEGRATION_UPDATE_REQUEST,
  BANK_INTEGRATION_UPDATE_REQUEST_SUCCESS,
  BANK_INTEGRATION_UPDATE_REQUEST_FAILURE,
  BANK_INTEGRATION_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  // pagination: {
  //   current: 0,
  //   pageSize: 0,
  //   total: 0,
  //   totalPage: 0,
  // },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const bankIntegrationReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case BANK_INTEGRATION_FETCH_REQUEST:
    case BANK_INTEGRATION_ADD_REQUEST:
    case BANK_INTEGRATION_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BANK_INTEGRATION_FETCH_REQUEST_SUCCESS:
    case BANK_INTEGRATION_ADD_REQUEST_FAILURE:
    case BANK_INTEGRATION_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        // pagination: {
        //   current: action.data.currentPage,
        //   pageSize: action.data.pageSize,
        //   total: action.data.totalRecord,
        //   totalPage: action.data.totalPage,
        //   showSizeChanger: true,
        // },
      });

    case BANK_INTEGRATION_FETCH_REQUEST_FAILURE:
    case BANK_INTEGRATION_ADD_REQUEST_SUCCESS:
    case BANK_INTEGRATION_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BANK_INTEGRATION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        // CRUDErrors: {},
        // pagination: {
        //   current: 0,
        //   pageSize: 0,
        //   total: 0,
        //   totalPage: 0,
        // },
      });

    default:
      return state;
  }
};

export default bankIntegrationReducer;
